import { L10nConfig, L10nProvider, L10nSchema } from 'angular-l10n';

interface SuppordedLanguage {
	schema: L10nSchema;
	provider: L10nProvider;
}
interface SupportedLanguages {
	enUS: SuppordedLanguage;
	nlNL: SuppordedLanguage;
}

type Language = keyof SupportedLanguages;

const supporedLanguages: SupportedLanguages = {
	enUS: {
		schema: { locale: { language: 'en-US', currency: 'USD' }, dir: 'ltr', text: 'United States' },
		provider: { name: 'en-US', asset: 'assets/i18n' },
	},
	nlNL: {
		schema: { locale: { language: 'nl-NL', currency: 'EUR' }, dir: 'ltr', text: 'Nederlands' },
		provider: { name: 'nl-NL', asset: 'assets/i18n' },
	},
};

export function getSupportedLanguagesConfig(languages: Language[], defaultLocale: Language) {
	const appSupportedLanguages: Language[] = languages.length ? [...languages] : (['enUS'] as Language[]);

	const schemasAndProviders = appSupportedLanguages.reduce(
		(pv, cv) => {
			const language = supporedLanguages[cv];
			if (language != null) {
				pv.schemas.push(language.schema);
				pv.providers.push(language.provider);
			}
			return pv;
		},
		{ schemas: [], providers: [] }
	);

	const config: L10nConfig = {
		defaultLocale: supporedLanguages[defaultLocale].schema.locale,
		cache: true,
		providers: schemasAndProviders.providers,
		keySeparator: '.',
		format: 'language-region',
		schema: schemasAndProviders.schemas,
	};

	return config;
}
